import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import Card from "./Card";

// Viewport settings for better animation triggering
const viewportSettings = {
  once: true,
  amount: 0.1,
  margin: "0px 0px -50px 0px",
};

const SecuritySection = () => {
  return (
    <section className="py-28">
      <div className="container-custom">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={viewportSettings}
          transition={{ duration: 0.6 }}
        >
          <Card className="overflow-hidden">
            <div className="flex flex-col lg:flex-row items-center gap-8 p-12">
              <div className="flex-1 text-center">
                <h2 className="text-3xl font-bold text-gray-900 mb-4">
                  Your privacy and security are our first priority
                </h2>
                <p className="text-gray-600 text-lg mb-6">
                  We hold ourselves to industry-leading privacy and security
                  standards and keep your data secure and private.
                </p>
                <Link
                  to="/security"
                  className="text-primary-600 font-semibold hover:text-primary-700 transition-colors inline-flex items-center gap-2"
                >
                  MORE ABOUT SECURITY AND DATA PRIVACY
                  <span>→</span>
                </Link>
              </div>
            </div>
          </Card>
        </motion.div>
      </div>
    </section>
  );
};

export default SecuritySection;
